import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'patientPaginationPipe',
  standalone: false
})
export class PatientPaginationPipe implements PipeTransform {
  transform(value: any[], currentPage: number, perpage: number): any {
    const result = value?.filter((curr, index) => {
      return index >= (currentPage - 1) * perpage && index < currentPage * perpage;
    });
    return result;
  }
}
